import type { PoseKeypoint } from 'shared/lib/tv-game/pose.ts';
import type { CalibNormMap } from '../domain/TargetDisplayState.ts';
import { applyNormFlip, toUnitScalarPose } from 'shared/lib/tv-game/normCoord.ts';

/**
 * Target Attack: each axis is **fraction of the game rect** (0 = 0%, 1 = 100%). Values outside
 * 0…1 are off-screen — we do **not** auto-fit a bounding box (that stretched the whole pose to
 * fill the canvas when e.g. `y ≈ 3.7` for ankles).
 */
export function keypointsToCalibMapWithRefs(
  kps: readonly PoseKeypoint[],
  normRefWidth: number | undefined,
  normRefHeight: number | undefined,
  flipX: boolean,
  flipY: boolean,
): CalibNormMap {
  const map: CalibNormMap = new Map();
  for (const kp of kps) {
    const nx0 = toUnitScalarPose(kp.x, normRefWidth);
    const ny0 = toUnitScalarPose(kp.y, normRefHeight);
    const { nx, ny } = applyNormFlip(nx0, ny0, { flipX, flipY });
    map.set(kp.type, { nx, ny });
  }
  return map;
}

export function rawToGameNormForTargetAttack(
  rawX: number,
  rawY: number,
  normRefWidth: number | undefined,
  normRefHeight: number | undefined,
  flipX: boolean,
  flipY: boolean,
): { nx: number; ny: number } {
  const n0 = toUnitScalarPose(rawX, normRefWidth);
  const n1 = toUnitScalarPose(rawY, normRefHeight);
  return applyNormFlip(n0, n1, { flipX, flipY });
}
